import { Component, Optional, SkipSelf } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetItem, GetAssetResponse } from '@assethub/shared/models';
import { BasicMenuComponent } from '../menu/basic-menu.component';
import { BasicMenuItemAssetComponent } from './basic-menu-item-asset.component';
import { LanguageService, LicensingService, TreeService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { CloneAssetModalComponent } from '../modals';
import { MenuItemComponent } from '../menu/menu-item/menu-item.component';

@Component({
  selector: 'app-menu-item-asset-clone',
  templateUrl: './basic-menu-item-asset.component.html',
  styleUrls: ['./basic-menu-item-asset.component.scss'],
  imports: [MenuItemComponent],
})
export class MenuItemAssetCloneComponent extends BasicMenuItemAssetComponent {
  constructor(
    sanitizer: DomSanitizer,
    @SkipSelf() @Optional() parentMenu: BasicMenuComponent | null,
    languageService: LanguageService,
    router: Router,
    activatedRoute: ActivatedRoute,
    treeService: TreeService,
    licensingService: LicensingService,
    private dialogService: DialogService,
  ) {
    super(
      sanitizer,
      parentMenu,
      languageService,
      router,
      activatedRoute,
      treeService,
      licensingService,
    );
    this.setup('content_copy', 'assetDetails.menu.clone');
  }

  static override isViableOption(
    asset: GetAssetResponse | AssetItem | undefined,
    opt: {
      treeService: TreeService;
    },
  ): boolean {
    if (BasicMenuItemAssetComponent.isManagedExternally(asset)) {
      return false;
    }

    if (!BasicMenuItemAssetComponent.isWritable(asset)) {
      return false;
    }

    const parent = BasicMenuItemAssetComponent.getParent(asset, opt.treeService);
    if (parent && !BasicMenuItemAssetComponent.isWritable(parent)) {
      // Cannot clone nodes below virtual root
      return false;
    }

    return true;
  }

  protected override getReason(): string {
    if (BasicMenuItemAssetComponent.isManagedExternally(this.asset)) {
      return 'managedExternally';
    }

    if (!BasicMenuItemAssetComponent.isWritable(this.asset)) {
      return 'cloneRequiresWrite';
    }

    const parent = BasicMenuItemAssetComponent.getParent(this.asset, this.treeService);
    if (parent && !BasicMenuItemAssetComponent.isWritable(parent)) {
      return 'cloneRequiresWriteOnParent';
    }

    return '';
  }

  override onClick() {
    if (!this.asset || this.disabled) {
      return;
    }
    super.onClick();
    this.dialogService.open(CloneAssetModalComponent, {
      header: this.languageService.instant('clone.title'),
      data: {
        asset: this.asset,
      },
    });
  }
}
